import { dataMember, required, typedArray } from 'santee-dcts';
import * as moment  from 'moment';

export interface HasRoles {
    roles: string[];
}

export class CommonLinkInfo implements HasRoles {
    @dataMember()
    @required()
    public commonLinkId: number;

    @dataMember()
    @required({ nullable: true})
    public description: string;

    @dataMember()
    @required()
    public url: string;

    @dataMember()
    @required()
    public title: string;

    @dataMember()
    @required({ nullable: true })
    public sortOrder: number;

    @dataMember({ customDeserializer: value => moment(value) })
    @required()
    public postedDate: moment.Moment;    

    @dataMember()
    @required()
    @typedArray(String)
    public roles: string[];
}

export class CommonLinksInfoRealModel {
    @dataMember()
    @required()
    @typedArray(CommonLinkInfo)
    public commonLinksInfo: CommonLinkInfo[];
}